// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__oQvkS","left":"InfoRow_left__2JuJ6"};